<template>
	<div ref="el" data-component="certification-state">
		<p class="-caption-regular title">{{ title }}</p>

		<div class="certification-pill">
			<p class="-caption-regular name">{{ name }}</p>

			<div class="state" :class="stateColor">
				<p class="-caption-regular">{{ state }}</p>
			</div>
		</div>
	</div>
</template>

<script setup>
import { Icon } from '~/components/core'

const props = defineProps({
	title: { type: String, default: 'No Title' },
	name: { type: String, default: 'No Name' },
	state: { type: String, default: 'No State' },
	stateColor: { type: String, default: 'tested' },
})

const el = ref(null)
const context = inject('pageContext')

const setup = () => {}
const init = () => {}
const kill = () => {}

onBeforeUnmount(() => {})
onMounted(() => {
	context.$page.loader.loaded.then(() => setup())
	context.$page.loader.transitionReady.then(() => init())
})
</script>

<style lang="scss" scoped>
[data-component='certification-state'] {
	position: relative;

	display: flex;
	flex-direction: column;

	.title {
		color: var(--color-neutral-tints-200);
		margin-bottom: rs(8, 8);
		padding-left: rs(12, 12);

		@include max-width($sm) {
			padding-left: 0;
		}
	}

	.certification-pill {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: rs(8, 8);

		border-radius: 199px;
		padding: rs(2, 2) rs(2, 2) rs(2, 2) rs(12, 12);

		background-color: var(--color-neutral-tints-700);
		color: var(--color-geral-white);

		.state {
			padding: rs(6, 6) rs(12, 12);
			border-radius: 199px;

			&.tested {
				background-color: var(--color-river-blue-900);
			}
			&.processing {
				background-color: var(--color-neutral-tints-500);
			}
		}

		.name,
		p {
			color: var(--color-geral-white);
		}
	}
}
</style>
